import { render, staticRenderFns } from "./YesNo.vue?vue&type=template&id=48915f4b&"
import script from "./YesNo.vue?vue&type=script&lang=js&"
export * from "./YesNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports